import React from 'react'

import type { Cta2Block as Cta2BlockProps } from '@/payload-types'

import RichText from '@/components/RichText'
import { CMSLink } from '@/components/Link'
import { cn } from '@/utilities/ui'
import { ChevronsRight } from 'lucide-react'

export const Cta2Block: React.FC<Cta2BlockProps> = ({ links, richText, description }) => {
  return (
    <section
      className={cn('relative py-4 bg-background not-prose')}
      aria-label="Cta2"
      style={{ backgroundColor: 'var(--primary)' }}
    >
      <div
        className={cn(
          'container mx-auto 2xl:px-0 flex flex-col md:flex-row items-center justify-between relative z-10 ',
        )}
      >
        <div className="flex flex-col justify-center w-full md:w-auto items-center md:items-start text-center md:text-left space-y-4">
          {richText && (
            <div className="text-3xl md:text-4xl lg:text-5xl font-bold text-primary-foreground leading-snug w-full">
              <RichText
                data={richText}
                enableGutter={false}
                enableProse={false}
                resetChildMargins
                style={{ fontFamily: 'var(--font-sans)' }}
              />
            </div>
          )}
          {description && (
            <div className="text-base max-w-none text-primary-foreground leading-relaxed w-full">
              <RichText
                data={description}
                enableGutter={false}
                enableProse={false}
                resetChildMargins
                style={{ fontFamily: 'var(--font-sans)' }}
              />
            </div>
          )}
        </div>
        {links && links.length > 0 && (
          <nav
            aria-label="Cta2 links"
            className="w-full md:w-auto md:ml-8 mt-3 md:mt-0 flex justify-center md:justify-end"
          >
            <ul className="flex flex-col md:flex-row gap-8 justify-center md:justify-end">
              {links.map((item, i) => (
                <li key={i}>
                  <div className="relative overflow-hidden group rounded-full inline-flex">
                    <CMSLink
                      {...item.link}
                      key={i}
                      className="z-10 inline-flex items-center border border-primary text-primary bg-primary-foreground hover:bg-primary/90 cursor-pointer font-semibold text-base tracking-wide transition-colors duration-300 rounded-full px-6 py-8"
                      aria-label={item.link.label || 'Learn more about this service'}
                    >
                      <div className="w-12 h-12 rounded-full flex flex-1 items-center justify-center ml-2 bg-primary text-primary-foreground">
                        <ChevronsRight />
                      </div>
                    </CMSLink>
                  </div>
                </li>
              ))}
            </ul>
          </nav>
        )}
      </div>
    </section>
  )
}
